/* eslint-disable import/prefer-default-export */

type GtagItem = {
  id: number | string;
};

export const trackAddToCartConversion = (items: GtagItem[], price: number) => {
  const mappedItems = items.map(({ id }) => ({
    id: `${id}`,
  }));

  try {
    global.gtag('event', 'conversion', {
      send_to: '11227710093/LgtxCJ_KkK8YEI2F5ekp',
      value: price,
      currency: 'USD',
      items: mappedItems,
    });
  } catch (e) {
    console.log('gtag error');
  }
};
